module.exports = __webpack_public_path__ + "static/media/bg-careers@2x.c514e1fc.jpg";